import React from 'react';
import styles from './style.module.css';
import StepTwoForm from '../../components/forms/step-two';

export default () => (
    <div className={styles.page}>
        <h1 className={styles.mainTitle}>Do you have current monthly debt payments?</h1>
        <StepTwoForm />
    </div>
);
